import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SocialsRow from "./Socials";
import { api, STORE } from "@/lib/api";
import { useAutoRefresh, useLiveEvent } from "@/lib/live";

export default function Footer() {
  const [storeOpen, setStoreOpen] = useState(null);

  const refresh = useCallback(() => {
    api.get("/store-status").then((r) => setStoreOpen(r.data.open)).catch(() => {});
  }, []);

  useEffect(() => { refresh(); }, [refresh]);
  useAutoRefresh(refresh, 45000); // allineamento periodico con le altre sessioni
  useLiveEvent("store-status-changed", (open) => setStoreOpen(open)); // aggiornamento istantaneo stessa sessione

  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0C] border-t border-white/10 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img src="/logo-rosa.png" alt="Rosa dei venti WANTED" className="h-9 w-9 object-contain" />
            <img src="/logo-scritta.png" alt="WANTED" className="h-5 w-auto object-contain" />
          </div>
          <p className="text-sm text-zinc-500 leading-relaxed max-w-xs">
            Il caveau dei collezionisti TCG. Carte singole, box sigillati e graded cards
            con programma fedeltà omnichannel.
          </p>
          {storeOpen !== null && (
            <p data-testid="footer-store-status" className="mt-5 inline-flex items-center gap-2.5 text-xs font-mono uppercase tracking-widest font-bold border border-white/10 rounded-full px-4 py-2">
              <span className="relative flex h-2.5 w-2.5">
                {storeOpen && <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-60" aria-hidden />}
                <span className={`relative inline-flex rounded-full h-2.5 w-2.5 ${storeOpen ? "bg-emerald-400" : "bg-red-500"}`} />
              </span>
              <span className={storeOpen ? "text-emerald-400" : "text-red-400"}>{storeOpen ? "Negozio aperto" : "Negozio chiuso"}</span>
            </p>
          )}
          <div className="mt-6">
            <SocialsRow />
          </div>
        </div>
        <div>
          <h4 className="text-xs font-mono uppercase tracking-[0.25em] text-red-500 font-semibold mb-5">Lo store</h4>
          <p className="text-sm font-semibold text-white">{STORE.name}</p>
          <p className="text-xs text-zinc-500 mt-1.5 leading-relaxed">{STORE.address}</p>
          <p className="text-xs text-zinc-500 mt-1">{STORE.hours}</p>
          <p className="text-xs text-zinc-500 mt-1">{STORE.email}</p>
        </div>
        <div>
          <h4 className="text-xs font-mono uppercase tracking-[0.25em] text-red-500 font-semibold mb-5">Wanted</h4>
          <ul className="space-y-3 text-sm text-zinc-400">
            <li><Link to="/catalogo" className="hover:text-white transition-colors">Catalogo</Link></li>
            <li><Link to="/fedelta" className="hover:text-white transition-colors">Programma Fedeltà</Link></li>
            <li><Link to="/ordini" className="hover:text-white transition-colors">I miei ordini</Link></li>
            <li><Link to="/chi-siamo" className="hover:text-white transition-colors">Chi Siamo</Link></li>
            <li><Link to="/contatti" className="hover:text-white transition-colors">Contatti</Link></li>
            <li><Link to="/faq" data-testid="footer-faq-link" className="hover:text-white transition-colors">Domande frequenti (FAQ)</Link></li>
            <li><Link to="/diventa-creator" data-testid="footer-creator-link" className="hover:text-white transition-colors">Diventa Creator</Link></li>
            <li><Link to="/note-legali" data-testid="footer-legal-link" className="hover:text-white transition-colors">Regole UE e-commerce</Link></li>
            <li><Link to="/termini" data-testid="footer-terms-link" className="hover:text-white transition-colors">Termini e Condizioni</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white transition-colors">Privacy Policy</Link></li>
            <li><Link to="/cookie" data-testid="footer-cookie-link" className="hover:text-white transition-colors">Cookie Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center">
        <p className="text-xs font-mono text-zinc-500 tracking-widest uppercase" data-testid="footer-company">Wanted SRL — P.IVA: 13526730018</p>
      </div>
    </footer>
  );
}
